import randomJA from "operators/randomImages/randomJA";


export default randomJA;